
// generated with scripts/generate_build_environment.sh
export const buildEnv = {
  projectName: 'igbce',
  buildVersion: '74d7dcf3',
  buildTimestamp: '2026-07-28T14:53:32+0000',
  customCss: 'assets/projects/igbce/custom.css?version=74d7dcf3',
  customJs: 'assets/projects/igbce/custom.js?version=74d7dcf3'
};
